import request from "@/api/request";
import { Role } from "@/interfaces/Role";

class RoleService {
  static async getRoles(): Promise<Role[]> {
    return await request.get("/roles");
  }
}

export default RoleService;
